'use strict';



var Directive = function($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            scope.errorDownload = false;
            scope.errorPDF = false;

            element.bind('click', function (event) {
                event.preventDefault();
                scope.errorDownload = false;
                scope.errorPDF = false;

                var httpRequest = new XMLHttpRequest();
                httpRequest.open('GET', attr.url, true);
                httpRequest.responseType = 'arraybuffer';

                var token = $window.localStorage.getItem('auth');
                var accessToken = $window.localStorage.getItem('access-token');
                var client = $window.localStorage.getItem('client');
                var uid = $window.localStorage.getItem('uid');

                if (null != token) {
                    httpRequest.setRequestHeader('auth', token);
                }
                if (accessToken) {
                    httpRequest.setRequestHeader('access-token', accessToken);
                    httpRequest.setRequestHeader('client', client);
                    httpRequest.setRequestHeader('uid', uid);
                }
                if (myConfig.domain) {
                    httpRequest.setRequestHeader('x-domain', myConfig.domain);
                }
                if (attr.secureKey) {
                    httpRequest.setRequestHeader('x-secure-key', attr.secureKey);
                }

                httpRequest.onload = function () {
                    if (200 === httpRequest.status) {
                        var blob = new Blob([httpRequest.response],
                            {type: httpRequest.getResponseHeader('content-type')});
                        var url =  URL.createObjectURL(blob);
                        var filename = 'resume';
                        var contentDisposition = httpRequest.getResponseHeader('content-disposition');

                        if (contentDisposition) {
                            var utf8Filename = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
                            var quotedFilename = contentDisposition.match(/filename="([^"]+)"/i);
                            var plainFilename = contentDisposition.match(/filename=([^;]+)/i);
                            var matchedFilename = utf8Filename || quotedFilename || plainFilename;

                            if (matchedFilename) {
                                filename = matchedFilename[1].trim().replace(/^["']|["']$/g, '');

                                if (utf8Filename) {
                                    try {
                                        filename = decodeURIComponent(filename);
                                    } catch (error) {
                                        // Keep the encoded name if the header contains invalid escaping.
                                    }
                                }
                            }
                        }

                        if (null != attr.download) {
                            // IE
                            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                                window.navigator.msSaveOrOpenBlob(blob, filename);
                            } else {
                                // create an "a" element so we can download the file
                                var a = document.createElement('a');
                                document.body.appendChild(a);
                                a.id = 'downloadAux';
                                a.href = url;
                                a.download = filename;
                                $('#downloadAux').css('display', 'none');
                                a.click();
                                document.getElementById('downloadAux').remove();
                                setTimeout(function () {
                                    URL.revokeObjectURL(url);
                                }, 1000);
                            }
                        } else {
                            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                                window.navigator.msSaveOrOpenBlob(blob, filename);
                            } else {
                                window.open(url);
                            }
                        }
                    } else {
                        if (null != attr.download) {
                            scope.errorHgDownload = true;
                        } else {
                            scope.errorPDF = true;
                        }
                    }
                };

                httpRequest.send();
            });
        }
    };
};

Directive.$inject = ['$window'];

module.exports = Directive;
